<div *ngIf="testsList$ && (testsList$ | async) as tests" class="list-container" #container>
  <div *ngFor="let test of tests" (click)="handleTestClicked(test)" class="item Spacebox__tb-mini Spacebox__lr-mini"
    [ngClass]="{ 'current': test.revisionId === currentRevisionId }">
    <ispm-vertical-test-actions-item [test]="test"></ispm-vertical-test-actions-item>
  </div>
</div>
